import { emptyBenefitAmountReport } from "./VEBReports/emptyBenefitAmountReport";
import { emptyRiderBenefitAmountReport } from "./VEBReports/emptyRiderBenefitAmountReport";
import { invalidMemberSSNFromVEBEnrollmentReport } from "./VEBReports/invalidMemberSSNFromVEBEnrollmentsReport";
import { invalidSubPlanReport } from "./VEBReports/invalidSubPlanReport";
import { activeGroupPlanNullEffectiveDateReport } from "./groupReports/activeGroupPlanNullEffectiveDateReport";
import { activePaycheckLessThanOneReport } from "./groupReports/activePaycheckLessThanOneReport";
import { dependentMoreThanEqualTo26YearsReport } from "./groupReports/dependentMoreThanEqualTo26Years";
import { invalidStateForMemberReport } from "./groupReports/invalidStateForMemberReport";
import { invalidZIPForMemberReport } from "./groupReports/invalidZIPForMemberReport";
import { notExistMemberLocationReport } from "./groupReports/notExistMemberLocationReport";

export const dataIntegrityReports = {
	groupReports: {
		invalidStateForMemberReport,
		invalidZIPForMemberReport,
		notExistMemberLocationReport,
		activeGroupPlanNullEffectiveDateReport,
		activePaycheckLessThanOneReport,
		dependentMoreThanEqualTo26YearsReport
	},
	VEBReports: {
		emptyBenefitAmountReport,
		emptyRiderBenefitAmountReport,
		invalidSubPlanReport,
		invalidMemberSSNFromVEBEnrollmentReport
	}
};
